// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useLocation } from 'react-router-dom';

const getRedirectTarget = (search: string): string => {
  const params = new URLSearchParams(search);
  const redirectUri = params.get('redirectUri');
  if (!redirectUri) {
    return '';
  }
  try {
    const parsed = new URL(redirectUri, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return '';
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return '';
  }
};

const E = (): JSX.Element => {
  const location = useLocation();
  const redirectUri = getRedirectTarget(location.search);

  window.location.href = `/api/sso/start?redirectUri=${encodeURIComponent(redirectUri)}`;
  return <></>;
};

export default E;
